// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/2b664e1ecbde3bfed018.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"7384094f566f28d239fd","175":"7b877b68c3eca9218266","176":"25b9c4337fb9ca6e3225"}[chunkId] + ".chunk.js";
};